<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11></v-flex>
    </v-layout>
    <v-layout row>
      <v-flex class="containerStyle2" md10 lg10 xs12 sm11 v-if="typeEstrategico == '1' ">
        <v-layout>
          <v-flex md12 lg12 xs12 sm12>
            <h4 class="pull">{{tipodimension}}</h4>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex md12 lg12 xs12 sm12>
            <v-card class="pull v-card-new">
              <h5 class="pullTitle">Evaluación General de la Dimensión</h5>

              <p class="text-vision">{{this.dimension.evaluacionGeneral}}</p>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-btn color="#394049" @click="dialog = true">Editar Evaluación General de la Dimensión</v-btn>
      <v-btn
        v-if="this.$session.getAll().userType == 'postgradodca'"
        color="#394049"
        @click="openAprobacion"
      >Aprobación DCa</v-btn>
      <v-btn
        v-if="this.$session.getAll().userType != 'postgradodca'"
        color="#394049"
        @click="openViewAprobacion()"
      >Estado de aprobación DCA</v-btn>

      <v-btn
        v-if="this.$session.getAll().userType == 'postgrado'"
        color="#394049"
        @click="openAprobacionPost"
      >Aprobación Programa</v-btn>
      <v-btn
        v-if="this.$session.getAll().userType != 'postgrado'"
        color="#394049"
        @click="openViewAprobacionPost()"
      >Estado de aprobación Programa</v-btn>

      <v-btn  color="#394049"  dark  @click="video = true">
        <v-icon dark>video_library</v-icon>
      </v-btn>
    </v-layout>
    <v-layout>
      <v-dialog v-model="dialog" width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Editar evaluación general de la dimensión</span>
          </v-card-title>
          <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
            <v-layout row>
              <v-flex md12 lg12 xs12 sm12>
                <label for="comment">Evaluación General de la Dimensión</label>
                <textarea
                  v-model="dimension.evaluacionGeneral"
                  type="text"
                  rows="10"
                  class="form-control"
                  id="comment"
                />
              </v-flex>
            </v-layout>
          </v-flex>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat="flat" @click="dialog = false">Cerrar</v-btn>
            <v-btn color="#394049" flat="flat" @click="updateGeneral()">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="aprobacion" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-dialog">
            <v-card-title v-if="create">
              <span class="headline">¿Desea aprobar la etapa?</span>
            </v-card-title>
            <v-card-title v-if="!create">
              <span class="headline">Estado de aprobación</span>
            </v-card-title>
            <v-layout v-if="!create">
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <h4 v-if="this.etapa.etapa3Dca">Aprobado por DCA</h4>
                <h4 v-if="!this.etapa.etapa3Dca">Aún no hay aprobación por parte de DCA</h4>
                <h4>{{etapa.fechaEtapa3}}</h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="usr">Observación</label>
                <textarea
                  v-model="obsEtapa"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                  :disabled="this.$session.getAll().userType != 'postgradodca'"
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat="flat" @click="aprobacion = false">Cerrar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgradodca'"
                color="red"
                flat="flat"
                @click="checkPro(false)"
              >desaprobar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgradodca'"
                color="#394049"
                flat="flat"
                @click="checkPro(true)"
              >aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 sm11 hidden-md-and-up>
        <v-dialog v-model="aprobacionPost" width="500">
          <template v-slot:activator="{ on }"></template>
          <v-card class="v-card-dialog">
            <v-card-title v-if="create">
              <span class="headline">¿Desea aprobar la etapa?</span>
            </v-card-title>
            <v-card-title v-if="!create">
              <span class="headline">Estado de aprobación</span>
            </v-card-title>
            <v-layout v-if="!create">
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <h4 v-if="this.etapa.etapa3Otro">Aprobado por Programa</h4>
                <h4 v-if="!this.etapa.etapa3Otro">Aún no hay aprobación por parte del programa</h4>
                <h4>{{etapa.fechaEtapa3Gral}}</h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex offset-md1 offset-lg1 offset-xs1 offset-sm1 md10 lg10 xs10 sm10>
                <label for="usr">Observación</label>
                <textarea
                  v-model="obsEtapaPost"
                  type="text"
                  rows="3"
                  class="form-control"
                  id="usr"
                  :disabled="this.$session.getAll().userType != 'postgrado'"
                />
              </v-flex>
            </v-layout>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" flat="flat" @click="aprobacionPost = false">Cerrar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgrado'"
                color="red"
                flat="flat"
                @click="checkPrograma(false)"
              >desaprobar</v-btn>
              <v-btn
                v-if="this.$session.getAll().userType == 'postgrado'"
                color="#394049"
                flat="flat"
                @click="checkPrograma(true)"
              >aprobar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-dialog v-model="video" width="1000">
        <template v-slot:activator="{ on }"></template>
        <v-toolbar dark color="#eb7704">
          <v-btn icon dark @click="pauseVideo()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card class="v-card-dialog">
          <video controls id="myVideo">
            <source :src="video1" type="video/mp4" />
          </video>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import img1 from "../../../assets/BANNER_6.png";
import img3 from "../../../assets/nuevaasistenciadca.png";
import video1 from "../../../assets/video3.mp4";

export default {
  data() {
    return {
      video: "",
      video1: video1,
      obsEtapaPost: "",
      aprobacionPost: "",
      nEtapa: 3,
      etapa: "",
      obsEtapa: "",
      create: "",
      aprobacion: "",
      dimension: "",
      tipodimension: " ",

      evaluacionGral: "",

      img3: img3,
      asistencia: false,

      create: false,
      edit: false,
      index: "",
      dialog: false,
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },
      filesDge: "",
      img1: img1,

      right: null
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.initComponent();
    }
  },

  created() {
    this.initComponent();
  },
  methods: {
    openAprobacion() {
      this.aprobacion = true;
      this.create = true;
    },
    openViewAprobacion() {
      this.aprobacion = true;
      this.create = false;
    },

    openAprobacionPost() {
      this.aprobacionPost = true;
      this.create = true;
    },
    openViewAprobacionPost() {
      this.aprobacionPost = true;
      this.create = false;
    },

    checkPrograma(booleanValue) {
      this.aprobacionPost = false;
      this.etapa["comentarioEtapa" + this.nEtapa + "Gral"] = this.obsEtapaPost;
      this.etapa["etapa" + this.nEtapa + "Otro"] = booleanValue;
      var tipo = "";
      if (booleanValue) {
        tipo = "aprobada";
      } else {
        tipo = "desaprobada";
      }
      //console.log(this.nEtapa);
      axios
        .patch(
          process.env.ROOT_API +
            "/etapa/updateEtapaGral?etapaNum=" +
            this.nEtapa,
          this.etapa,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initObservacionGral();
          alert("Etapa 3 ha sido " + tipo);
        })
        .catch(error => {
          console.error(error);
          this.initObservacionGral();
          alert("Error:" + error);
        });
    },

    checkPro(booleanValue) {
      this.aprobacion = false;
      this.etapa["comentarioEtapa" + this.nEtapa] = this.obsEtapa;
      this.etapa["etapa" + this.nEtapa + "Dca"] = booleanValue;
      var tipo = "";
      if (booleanValue) {
        tipo = "aprobada";
      } else {
        tipo = "desaprobada";
      }
      //console.log(this.nEtapa);
      axios
        .patch(
          process.env.ROOT_API +
            "/etapa/updateEtapaDca?etapaNum=" +
            this.nEtapa,
          this.etapa,
          this.auth
        )
        .then(response => {
          //console.log(response.data)
          this.initObservacionGral();
          alert("Etapa 3 ha sido " + tipo);
        })
        .catch(error => {
          console.error(error);
          this.initObservacionGral();
          alert("Error:" + error);
        });
    },
    redirect(index) {
      this.typeEstrategico = index;
    },
    sendDge() {
      this.asistencia = false;
      alert("Tus inquietudes han sido enviadas, pronto te contactaremos.");
    },

    initComponent() {
      axios
        .get(
          process.env.ROOT_API +
            "/dimensionGral/getByCarreraAndDimension?idCarrera=" +
            this.$session.getAll().ccData.id +
            "&idDimension=" +
            this.$route.params.id,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.tipodimension = response.data.nombre;
          this.dimension = response.data;
        })
        .catch(error => {
          //console.log("ERROR ANEXOS");
          console.error(error);
          this.showAlert("error", error.response.data);
        });
      this.initObservacionGral();
    },

    initObservacionGral() {
      axios
        .get(
          process.env.ROOT_API +
            "/etapa/etapaUsuario?idPostgrado=" +
            this.$session.getAll().ccData.id,
          this.auth
        )
        .then(response => {
          //console.log("ANEXOS");
          //console.log(response.data);
          this.obsEtapa = response.data["comentarioEtapa" + this.nEtapa];
          this.obsEtapaPost =
            response.data["comentarioEtapa" + this.nEtapa + "Gral"];
          this.etapa = response.data;
          //console.log(this.obsEtapa);
        })
        .catch(error => {
          //console.log("ERROR ANEXOS");
          console.error(error);
          this.showAlert("error", error.response.data);
        });
    },

    getEvaluaciones(idDimension) {
      //console.log("jhdkjahdkjhakjdhajkshdkjashdkjas: " + idDimension);
      //console.log("ccCompelte: " + this.$session.getAll().ccData.id);
      axios
        .get(
          process.env.ROOT_API +
            "/evaluacion/getAllByDimensionAndCarrera?idCarrera=" +
            this.$session.getAll().ccData.id +
            "&idDimension=" +
            idDimension,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.evaluaciones = response.data;
          this.dimension = response.data[0].dimension;
          this.evaluacionGral = this.dimension.evaluacionGeneral;
          this.tipodimension = response.data[0].dimension.nombre;
          this.headers[0].text = this.tipodimension;
          //this.getFyd();
        })
        .catch(error => {
          console.error(error);
        });
    },

    /* deleteFD(item) {
      //console.log(item.id);
      axios
        .delete(
          process.env.ROOT_API + "/fyd/delete?idFyD=" + item.id,
          this.auth
        )
        .then(response => {
          this.getFyd();
          alert(response.data);
        })
        .catch(error => {
          console.error(error);
        });
    }, */

    downloadFile(index) {
      //console.log("Descargando archivo ....");
      var pathFile = this.convertPath(this.filesDge.dge[index]["path"]);
      var nameFile = this.filesDge.dge[index]["name"];
      //console.log(nameFile);
      axios
        .get(
          "http://localhost:8089/uploadFileDcaEtc/downloadFile?dir=" + pathFile,
          {
            responseType: "arraybuffer",
            headers: { Authorization: "" + this.$session.get("jwt") }
          }
        )
        .then(response => {
          //console.log("archivo descargado ....");
          //console.log(response);
          this.forceFileDownload(response, nameFile);
        })
        .catch(error => {
          console.error(error);
        });
    },

    convertPath(string) {
      var info = string.split("\\").join("/");
      return info;
    },
    forceFileDownload(response, nameFile) {
      //console.log("Aqui va el header");
      //console.log(response.headers);
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: response.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", nameFile); //or any other extension
      document.body.appendChild(link);
      link.click();
    },

    updateGeneral() {
      this.dialog = false;
      axios
        .post(
          process.env.ROOT_API + "/dimensionGral/updateDimensionGeneral",
          this.dimension,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.initComponent();
          alert("Evaluación General de la Dimensión editada");
        })
        .catch(error => {
          console.error(error);
          this.initComponent();
          alert("Error:" + error);
        });
    },

    openEditEvaluaciones(evaluacion, index) {
      this.create = false;
      this.edit = true;
      this.index = index;
      this.evaluacion = evaluacion;
    },

    editEvaluacion() {
      this.edit = false;
      axios
        .post(
          process.env.ROOT_API + "/evaluacion/updateEvaluacion",
          this.evaluacion,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.initComponent();
          alert("Evaluación editada");
        })
        .catch(error => {
          console.error(error);
          this.initComponent();
          alert("Error:" + error);
        });
    },

    /* openEditFortaleza(fortaleza, index) {
      this.create = false;
      this.editFortaleza = true;
      this.index = index;
      this.fortaleza = fortaleza;
    },

    openEditDebilidad(debilidad, index) {
      this.create = false;
      this.editDebilidad = true;
      this.index = index;
      this.debilidad = debilidad;
    },

    opencreateFortaleza() {
      this.create = true;
      this.editFortaleza = true;
      this.fortaleza = {
        descripcion: "",
        tipo: "Fortaleza"
      };
    },

    opencreateDebilidad() {
      this.create = true;
      this.editDebilidad = true;
      this.debilidad = {
        descripcion: "",
        tipo: "Debilidad"
      };
    }, */

    /* editFortalezaF() {
      this.editFortaleza = false;
      axios
        .post(
          process.env.ROOT_API + "/fyd/updateFortalezaDebilidad",
          this.fortaleza,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.getFyd();
          alert("Fortaleza editada");
        })
        .catch(error => {
          console.error(error);
          this.getFyd();
          alert("Error:" + error);
        });
    },
    editDebilidadF() {
      this.editDebilidad = false;
      axios
        .post(
          process.env.ROOT_API + "/fyd/updateFortalezaDebilidad",
          this.debilidad,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.getFyd();
          alert("Debilidad editada");
        })
        .catch(error => {
          console.error(error);
          this.getFyd();
          alert("Error:" + error);
        });
    },

    createFortaleza() {
      this.editFortaleza = false;
      axios
        .post(
          process.env.ROOT_API +
            "/fyd/createFortalezaDebilidad?idDimension=" +
            this.dimension.id,
          this.fortaleza,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.getFyd();
          alert("Fortaleza Agregada");
        })
        .catch(error => {
          console.error(error);
          this.getFyd();
          alert("Error:" + error);
        });
    },

    createDebilidad() {
      this.editDebilidad = false;
      axios
        .post(
          process.env.ROOT_API +
            "/fyd/createFortalezaDebilidad?idDimension=" +
            this.dimension.id,
          this.debilidad,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.getFyd();
          alert("Debilidad Agregada");
        })
        .catch(error => {
          console.error(error);
          this.getFyd();
          alert("Error:" + error);
        });
    }, */

    replaceT(texto) {
      var newTexto = texto.replace(/\n/g, "<br />");
      //console.log(newTexto);
      return newTexto;
    },
    pauseVideo() {
      document.getElementById("myVideo").pause();
      this.video = false;
    }

    /* getFyd() {
      axios
        .get(
          process.env.ROOT_API +
            "/fyd/getAllByDimension?idDimension=" +
            this.dimension.id,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.fortalezas = response.data[0];
          this.debilidades = response.data[1];
        })
        .catch(error => {
          console.error(error);
          alert("Error:" + error);
        });
    }, */
  }
};
</script>


<style scoped>
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 150px !important;
}

.v-card-new {
  margin-bottom: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #4376a1 !important;
  height: 400px !important;
  overflow-y: auto;
}

.v-card {
  overflow-y: auto;
  height: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}
.text-vision {
  color: white;
  font-size: 12px;
}

.pull {
  text-align: justify;
}

.pullTitle {
  text-align: justify;
  font-size: 18px;
  color: white;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 200px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 11px;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
#myVideo {
  width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/dca/evaluacion/EvaluacionDimension.vue